<template>
  <div class="container">
    <div class="info-box">
      <div class="info">
        <img
          :src="infoItem.img_url"
          alt="专家"
          class="personImg"
        >
        <div class="ex-name-info">
          <span class="ex-name">{{infoItem.title}}</span>
          <img src="../assets/img/bigV.png" alt="认证" v-show="infoItem.is_auth === '1' ? true : false">
        </div>
        <div class="ex-intro">
          <img src="../assets/img/timeIcon.png" alt="">
          <span class="ex-time">{{infoItem.working_years}}年</span>
          <img src="../assets/img/bookIcon.png" alt="">
          <span class="ex-title">
            {{infoItem.working_certificate.join(' ')}}
          </span>
        </div>
      </div>
    </div>
    <div class="detail-intro">
      <div class="detail-top">
        <img
          :src="infoItem.img_url"
          alt="专家"
          class="personDetail"
        >
        <div class="top-two">
          <div class="top-name">
            <span>{{infoItem.title}}</span>
            <div>
              <img src="../assets/img/bigV.png" alt="认证" v-show="infoItem.is_auth === '1' ? true : false">
              <!--<span>玉雕大师</span>-->
            </div>
              
          </div>
          <div class="top-time">
            <p>
              <img src="../assets/img/timeIcon.png" alt="">
              <span class="ex-time">{{infoItem.working_years}}年</span>
            </p>
            <p>
              <img src="../assets/img/bookIcon.png" alt="">
              <span class="ex-title">
                 {{infoItem.working_certificate.join(' ')}}
              </span>
            </p>
          </div>
        </div>
      </div>
      <div class="detail-center" v-html="infoItem.content">
       
      </div>
      <div class="detail-serve">
        <p>可提供服务</p>
        <p>{{infoItem.provide_service}}</p>
      </div>
      <div class="btn">
        <el-button @click="handleAsk()">免费咨询</el-button>
      </div>
    </div>

    <!-- 免费咨询 -->
       <div class="consult-box" v-show="tipDialogVisible">
          <div class="mask">
                <div class="content">
                <img src="../assets/img/close.svg" alt="" class="close" @click="closeTips()">
                <img src="../assets/img/tips.png" alt="" class="tips">
                <div style="text-align: center">
                  <div>免费咨询请扫描下面微信小程序，在小程序里面发起咨询哦!</div>
                  <img style="width: 200px;height:auto;margin: 40px auto;" src="@/assets/img/mpBigQrCode.png" alt="">
                </div>
            </div>
          </div>
       </div>

  </div>
</template>

<script>
export default {
  name: "ExpertInfo",
  components: {},
  props: {
    infoItem: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
       tipDialogVisible:false
    };
  },
  watch: {},
  computed: {},
  methods: {
     wheelHandler(e){
      e.preventDefault();
    },
    handleOpen(type) {
      this.tipDialogVisible = true;
      window.addEventListener('wheel',this.wheelHandler,{
         passive:false,
      })
    },
    handleClose(type) {
        this.tipDialogVisible = false;
        window.removeEventListener('wheel',this.wheelHandler,{
         passive:false,
       })
    },
    handleAsk() {
      this.handleOpen();
    },
    onSubmitAsk(){
      this.handleClose();
    },
    closeTips() {
      this.handleClose();
    }
  },
  created() {},
  mounted() {

  },
};
</script>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.container {
  height: 100%;
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  i {
    color: rgba(32, 147, 202, 1);
    font-size: 12px;
    font-weight: 400;
  }
  .info-box {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
  }

  .info {
    height: 80%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;
    .ex-name-info {
      display: flex;
    }
    .personImg {
      width: 224px;
      height: 224px;
      border-radius: 14px;
      object-fit: cover;
      border-radius: 14px;
    }
    .ex-ex-name {
      color: rgba(26, 26, 26, 1);
      font-size: 20px;
      font-weight: 700;
    }
    .ex-circle {
      width: 12px;
      height: 12px;
      border: 1px solid rgba(32, 147, 202, 1);
      border-radius: 50%;
      display: inline-block;
    }
    .ex-intro {
      display: flex;
      .ex-title,
      span {
        color: rgba(26, 26, 26, 1);
        font-size: 12px;
        font-weight: 400;
      }
    }
  }
   .ex-time,.ex-title {
      margin-left: 5px;
      margin-right: 8px;
    }
  .detail-intro {
    height: 100%;
    width: 100%;
    border-radius: 14px;
    background: #ffffff;
    padding-bottom: 20px;
    position: absolute;
    z-index: 10;
    opacity: 0;
    transition: opacity 0.8s ease-out;
    &:hover {
      opacity: 1;
    }
    .detail-top {
      height: 30%;
      width: 100%;
      box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.08);
      padding: 0 14px;
      display: flex;
      // justify-content: center;
      align-items: center;
      .personDetail {
        width: 90px;
        height: 90px;
        border-radius: 50%;
        object-fit: cover;
      }
      .top-two {
        padding-left: 12px;
        .top-name {
          display: flex;
          justify-content: flex-start;
          //justify-content: space-between;
          align-items: baseline;
           &>:first-child {
              color: rgba(26, 26, 26, 1);
              font-size: 22px;
              font-weight: 700;
            }
          div{
            padding-left: 6px;
            display: flex;
            justify-content: center;
            align-items: center;
            span {
              color: rgba(26, 26, 26, 1);
              font-size: 12px;
              font-weight: 400;
              padding-left: 6px;
            }
          }
        }
       
        .top-time {
          p {
            display: flex;
            font-size: 12px;
            font-weight: 400;
          }
            p:nth-child(2) {
            padding-top: 6px;
          }
            p:first-child {
            padding-top: 10px;
          }
        }
      }
    }
    .detail-center {
      height: 40%;
      width: 100%;
      padding: 14px 14px 0 14px;
      line-height: 20px;
      font-size: 14px;
      font-weight: 400;
      overflow: hidden;
      text-overflow: ellipsis;
      word-wrap: break-word;
        white-space: normal !important;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 7;

    }
    .detail-serve {
      height: 16%;
      width: 100%;
      padding: 0 10px;
      box-sizing: border-box;
      line-height: 16px;
      p:first-child {
        color: rgba(32, 147, 202, 1);
        font-size: 12px;
        font-weight: 400;
      }
      p:last-child {
        line-height: 26px;
        font-size: 16px;
        font-weight: 400;
      }
    }
  }
  .btn {
    padding: 0 14px;
    .el-button {
      width: 100%;
      background: #2093ca;
      color: #ffffff;
      font-size: 20px;
      letter-spacing: 4px;
      border-radius: 100px;
    }
  }


   .consult-box {
    // width: 100vw;
    // height: 100vh;
   position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;
    z-index: 2030;
    background: rgb(0,0,0,60%);
    .mask {
        position: absolute;
        z-index: 999;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        // animation: dialog-fade-in 0.2s linear 1;
        
    }
     .content {
      //width: 570px;
      //height: 199px;
      border-radius: 14px;
      //background: url("../assets/img/tipsBg.png") no-repeat;
       background: linear-gradient(180deg, rgb(32, 147, 202) 0%,rgba(255,255,255,1) 20%);
      position: relative;
      animation: dialog-fade-in .5s;
      .close {
        position: absolute;
        z-index: 999;
        top: -15px;
        left: 100%;
        cursor: pointer;
      }
      .tips {
        position: absolute;
        top: 0;
        left: calc(50% - 30px);
        // transform: translateX(-50%);
        transform: translateY(-50%);
      }
      div {
        position: static;
        //height: 199px;
        padding: 30px 50px 0 50px;
        display: inline-flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        span {
         transform: translateY(50%);
         font-size: 16px;
         line-height: 20px;
         font-weight: 400;
         text-align: justify;
       }
      }
      .el-button {
        width: 240px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #2093ca;
        color: #ffffff;
        font-size: 20px;
        letter-spacing: 4px;
      }
     }
  }
}
@keyframes dialog-fade-in {
     0% {
        transform: translate(0, -100%);
        opacity: 0;
    }
    100% {
        transform: none;
        opacity: 1;
    }
}
</style>